export const inboxVisionAppGroupIdGetInboxVisionData = "/inbox_vision/:app_group_id/get_inbox_vision_data";
